import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';
import {Card, CardBody, Row, Col, Button} from 'reactstrap';
import 'url-search-params-polyfill';

import Form from '@/Form';
import Text from '@/Form/Text';
import {blank} from '@/util';
import Icon from '@/views/shared/Icon';
import api from '@/api';

import Separator from '@/views/shared/Separator';

import Tooltip from '@/views/shared/Tooltip';
import styles from '@/views/Activation/index.module.css';
import ActivateSuccess from '@/views/Activation/ActivateSuccess';

const metaFields = ['errors'];

const Activation = ({location}) => {
  const [formData, setFormData] = useState({});
  const [flashData, setFlashData] = useState({});
  const {t: tr} = useTranslation('activation');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const data = {
      login: R.defaultTo('')(params.get('login')),
      activationCode: R.defaultTo('')(params.get('activation_code')),
      password: '',
      passwordConfirmation: '',
    };

    setFormData(data);
  }, {});

  const handleSubmit = event => {
    event.preventDefault();

    api.post('/activate', R.omit(metaFields, formData)).then(({data}) => {
      const errors = R.propOr({}, 'errors')(data);
      if (blank(errors)) {
        setFlashData(data.success);
      }
      setFormData(R.assoc('errors', errors));
    });
  };

  if (blank(formData)) {
    return null;
  }

  if (!blank(flashData)) {
    return <ActivateSuccess loginId={R.prop('loginId')(flashData)} />;
  }

  return (
    <Form stateHook={[formData, setFormData]} onSubmit={handleSubmit}>
      <Card style={{border: '0px'}}>
        <CardBody className={styles.section}>
          <div className='text-center'>
            <h1 className={styles.title}>{tr('online_reg_title')}</h1>
            <Separator />
            <h4 className={styles.subtitle}>{tr('activate_sub_title')}</h4>
          </div>
          <Row>
            <Col md={{size: 4, offset: 4}}>
              {tr('login_id')}
              <Icon
                icon='question'
                id='question_icon'
                style={{margin: '0 10px 0 20px', color: 'red'}}
              />
              <Tooltip
                target='question_icon'
                text={tr('identification_number_tooptip_text')}
              />
              <Text
                name='login'
                placeholder={tr('identification_number_placeholder')}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col md={{size: 4, offset: 4}}>
              <Text name='activationCode' label={tr('code')} required />
            </Col>
          </Row>
          <Row>
            <Col md={{size: 4, offset: 4}}>
              <Text
                type='password'
                name='password'
                label={tr('new_password')}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col md={{size: 4, offset: 4}}>
              <Text
                type='password'
                name='passwordConfirmation'
                label={tr('password_confirmation')}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col md={{size: 4, offset: 4}} className='text-center'>
              <Button size='lg' type='submit' value='Y' color='secondary' block>
                {tr('submit')}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Form>
  );
};

export default Activation;
